export const Overview = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_3622_1463)">
        <path
          d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 2.25V5.25"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 2.25V5.25"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 8.25H20.25"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 11.25H10.507L8.7529 13.7558C9.04209 13.7558 9.32678 13.8274 9.58163 13.9641C9.83649 14.1007 10.0536 14.2983 10.2136 14.5392C10.3737 14.78 10.4717 15.0567 10.4989 15.3446C10.5261 15.6325 10.4818 15.9227 10.3698 16.1893C10.2577 16.4559 10.0815 16.6907 9.85684 16.8728C9.63214 17.0548 9.36592 17.1785 9.08187 17.2327C8.79783 17.287 8.50476 17.2702 8.22877 17.1839C7.95278 17.0975 7.70243 16.9442 7.5 16.7377"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6773 17.2639C15.9229 17.2639 16.9326 15.9177 16.9326 14.257C16.9326 12.5963 15.9229 11.25 14.6773 11.25C13.4318 11.25 12.4221 12.5963 12.4221 14.257C12.4221 15.9177 13.4318 17.2639 14.6773 17.2639Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3622_1463">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
